import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "create-group-modal-content__main-content main-content" }
const _hoisted_2 = { class: "main-content__container" }
const _hoisted_3 = { class: "main-content__title" }

import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { i18n } from '@/i18n';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateGroupModal',
  props: {
    modalState: { type: Boolean }
  },
  emits: ["close", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

//変数
const t = i18n.t;

const inputText = ref('');

const isDisabledApplyButton = computed(() => {
  return inputText.value === '';
});

watch(
  () => props.modalState,
  (newVal) => {
    console.log('newVal', newVal);
    if (newVal) {
      inputText.value = '';
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('新規作成'),
    "modal-width": 764,
    "is-disabled-next-button": isDisabledApplyButton.value,
    onOnBack: _cache[1] || (_cache[1] = ($event: any) => (emits('close'))),
    onOnNext: _cache[2] || (_cache[2] = ($event: any) => (emits('apply', inputText.value)))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('グループの新規作成')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('取引をまとめる任意のグループを新規作成します。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('グループを新規作成')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputText).value = $event)),
            type: "text",
            class: "main-content__input"
          }, null, 512), [
            [_vModelText, inputText.value]
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})